import React from 'react';
import ProtectedField from 'components/ProtectedField/ProtectedField';
import { LABEL_VALUE_CONFIG, AVAILABLE_FIELD_KEYS } from './fields';

//Get label and value configuration for a single field
export const getSharedLabelAndValue = (fieldKey, data, transportationData, options = {}) => {
  const config = LABEL_VALUE_CONFIG[fieldKey];

  if (!config) {
    if (process.env.NODE_ENV === 'development') {
      console.error(
        `❌ getSharedLabelAndValue: Invalid field key "${fieldKey}"\n` +
          `Available keys: ${AVAILABLE_FIELD_KEYS.join(', ')}`,
      );
    }
    return {
      label: 'N/A',
      value: 'N/A',
      tooltipText: 'N/A',
    };
  }

  const extractedValue = config.getValue?.(data, transportationData) ?? null;
  const formattedValue = config.formatValue?.(extractedValue, options);

  const field = {
    label: config.label,
    value: formattedValue,
    tooltipText: config.tooltipText,
  };

  if (config.withCopyIcon) {
    field.withCopyIcon = true;
  }

  if (config.getCopyValue) {
    field.copyValue = config.getCopyValue(data);
  }

  if (options.isEllipsisWithTooltip !== undefined) {
    field.isEllipsisWithTooltip = options.isEllipsisWithTooltip;
  } else if (config.isEllipsisWithTooltip !== undefined) {
    field.isEllipsisWithTooltip = config.isEllipsisWithTooltip;
  }

  return field;
};

//Get label and value configurations for multiple fields
export const getSharedLabelsAndValues = (fieldKeys, data, transportationData, options = {}) => {
  return fieldKeys
    .map((fieldKey) => getSharedLabelAndValue(fieldKey, data, transportationData, options))
    .filter(Boolean);
};

//Get protected field configuration (for fields requiring keycode access)
export const getSharedProtectedLabelAndValue = (
  fieldKey,
  displayProtectedAttributes,
  getProtectedAttribute,
  vehicleCodesLoading,
  isKeycodeEnabled,
  isPrint,
) => {
  const config = LABEL_VALUE_CONFIG[fieldKey];

  if (!config) {
    if (process.env.NODE_ENV === 'development') {
      console.error(
        `❌ getSharedProtectedLabelAndValue: Invalid field key "${fieldKey}"\n` +
          `Available keys: ${AVAILABLE_FIELD_KEYS.join(', ')}`,
      );
    }
    return {
      label: 'N/A',
      value: 'N/A',
    };
  }

  const isKeyCodeLoading =
    displayProtectedAttributes?.current === config.fieldName && vehicleCodesLoading;

  return {
    label: config.label,
    value: (
      <ProtectedField
        field={config.fieldName}
        value={displayProtectedAttributes?.[config.fieldName]}
        handleClick={getProtectedAttribute}
        enableButton={isKeycodeEnabled}
        loading={isKeyCodeLoading}
        isPrint={isPrint}
      />
    ),
  };
};
